import React from 'react'

export default function Rules() {
    return (
      <div className='rules-container'>
        <h1>REGLAS DEL JUEGO</h1>
        <h3>Descripcion de las reglas del juego</h3>

        <h4>Memorias de la Habladora</h4>
        <p>Del lado derecho de la ilustración encontrarás la descripción de las situaciones que debes buscar dentro de la imagen. Mira con cuidado la imagen y haz clic sobre el lugar donde está el símbolo del grupo étnico que buscas. ¡Podrás avanzar a la siguiente cultura una vez encuentres los 6 símbolos de cada una y ganar el juego una vez encuentres todos los símbolos!</p>
      </div>
    );
}
